module.exports = __webpack_public_path__ + "static/media/logo.671bf876.jpg";